module.exports = __webpack_public_path__ + "img/478-ff8576.png";